export const SdwanMobileFive = () => {
    return <div>
        <div className="mt-[45px] flex justify-center px-[45px]"><div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">全行业多场景支持</div></div>
        <div className="flex justify-center mt-[10px] px-[45px]">
            <div className="text-[8px] font-regular text-[rgba(51,51,51,1)] text-center">
                支持跨境企业相关的办公、营销、电商、直播等多场景
            </div>
        </div>
        <div className="grid grid-cols-2 gap-[10px] mt-[20px] px-[10px]">
            <Item
                title="企业办公应用加速"
                content="企业办公、SaaS应用加速，异地传输，不同办公点的跨国际互通互访。轻松满足千人团队同时在线使用。"
                img="/imgs/sdwan/scene/1.png"
            />
            <Item
                title="海外直播"
                content="支持TikTok等全球热门跨境多平台跨境高清直播。确保IP纯净，可选择家庭宽带IP、静态住宅IP(双ISP)等"
                img="/imgs/sdwan/scene/2.png"
            />
            <Item
                title="跨境电商"
                content="优化网站加载速度和数据传输效率，帮助电商快速响应全球客户需求；轻松访问各国家地区的亚马逊、Etsy等电商平台"
                img="/imgs/sdwan/scene/3.png"
            />
            <Item
                title="全球应用加速"
                content="海外音频、视频、社交媒体加速 ，跨国稳定访问合规的音视频与社媒应用内容。与海外客户建联变得更容易。"
                img="/imgs/sdwan/scene/4.png"
            />
            <Item
                title="企业组网/私有化部署"
                content="助力跨国企业搭建自有安全、稳定、高效的全球跨国组网平台，适用于数据安全性、传输带宽及组网成员需要灵活部署的企业或项目"
                img="/imgs/sdwan/scene/5.png"
            />
            <Item
                title="视频矩阵"
                content="用专线网络和独享静态IP打造矩阵运营网络避免限流封号，实现批量起号养号。"
                img="/imgs/sdwan/scene/6.png"
            />
            <Item
                title="多店铺管理"
                content="适用于拥有数百个店铺的卖家，通过独立环境独享IP，降低封店率并提升运营稳定性，适用于亚马逊、SHEIN、TEMU跨境电商卖家。"
                img="/imgs/sdwan/scene/7.png"
            />
            <Item
                title="游戏出海加速"
                content="助力国内游戏厂商，游戏出海加速，让游戏使用同一个加速域名接入全球玩家。同时解决游戏发行、游戏跨国宣发网络加速需求。"
                img="/imgs/sdwan/scene/8.png"
            />
            <Item
                title="企业组网/全球多云互联"
                content="解决跨国企业使用多个云平台的管理难题，可实现多云互联，如AWS、腾讯云、阿里云、IBM等内部组网多云互联。"
                img="/imgs/sdwan/scene/9.png"
            />
            <Item
                title="海外社媒广告营销"
                content="使用安全合规的国际专线绑定静态住宅IP，保障海外社媒账号的稳定访问与账号安全,GoogleADS、Yandex等海外营销更顺畅。"
                img="/imgs/sdwan/scene/10.png"
            />
            <Item
                title="AIGC加速"
                content="ChatGPT、Sora等AI工具访问使用限制，轻松完成账号注册使用，提高业务效率。"
                img="/imgs/sdwan/scene/11.png"
            />
            <Item
                title="游戏加速器"
                content="通过自研KWAN加速引擎，搭建的一款游戏加速工具，支持全球游戏加速，轻松玩Steam、EPIC等外服游戏。"
                img="/imgs/sdwan/scene/12.png"
            />
        </div>



    </div>
}


export const Item = (props: {
    title: string;
    content: string;
    img: string;
}) => {
    return (
        <div className="w-full bg-white shadow-[0px_4px_10px_0px_rgba(0,0,0,0.06)] rounded-[4px] px-[10px] pt-[20px] pb-[10px] relative">
            <img
                className="w-[24px] h-[24px] absolute top-[10px] right-[8px]"
                src={props.img}
            />
            <div className="font-normal text-[12px] text-left bg-gradient-to-t from-[#72B3FF] to-[#A8A0FF] bg-clip-text text-transparent">
                {props.title}
            </div>
            <div className="font-normal text-[10px] text-[#333333] mt-[8px]">
                {props.content}
            </div>
        </div>
    );
};
